import { useInfiniteQuery } from "@tanstack/react-query";
import {
  getFieldRelationListForEntityInstanceId,
  PaginationData,
} from "@/services/entity-instance.service";

export const useRelationEntityList = ({
  entityName,
  id,
  fieldName,
  fieldsToFetchForRelationFieldNames,
  enabled = true,
}: {
  entityName: string;
  id?: string;
  fieldName: string;
  fieldsToFetchForRelationFieldNames?: Array<{
    fieldName: string;
    fieldsToFetch: Array<string>;
  }>;
  enabled?: boolean;
}) => {
  return useInfiniteQuery({
    queryKey: [
      "relation-field-entity-instance-by-id",
      entityName,
      id,
      fieldName,
      fieldsToFetchForRelationFieldNames,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const result = await getFieldRelationListForEntityInstanceId({
        entityName: entityName,
        id: id!,
        pagination: { page: pageParam, per_page: 20 },
        fieldsToFetchForRelationFieldNames,
        fieldName,
      });

      return result as {
        data: object | Array<object>;
        pagination?: PaginationData;
      };
    },

    getNextPageParam: (lastPage) => {
      return lastPage?.pagination?.has_more_pages
        ? lastPage.pagination.current_page + 1
        : undefined;
    },
    initialPageParam: 1,
    enabled: !!id && enabled,
    refetchOnMount: "always",
  });
};
